export default "__VITE_ASSET__C$pTNwjI__ 400w, __VITE_ASSET__DUzBvl6s__ 800w, __VITE_ASSET__CsyBniQB__ 1024w";